"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FileSaver = require("file-saver");

var React = require("react");

var csv_1 = require("./lib/csv");

var CsvDownload =
/** @class */
function (_super) {
  __extends(CsvDownload, _super);

  function CsvDownload() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.handleClick = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, suffix, prefix, bom, csv, bomCode, filename, blob;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _a = this.props, suffix = _a.suffix, prefix = _a.prefix, bom = _a.bom;
              return [4
              /*yield*/
              , csv_1.default(this.props)];

            case 1:
              csv = _b.sent();
              bomCode = bom ? "\uFEFF" : '';
              filename = this.props.filename;

              if (filename.indexOf('.csv') === -1) {
                filename += '.csv';
              }

              if (suffix) {
                filename = typeof suffix === 'string' || typeof suffix === 'number' ? filename.replace('.csv', "_" + suffix + ".csv") : filename.replace('.csv', "_" + new Date().getTime() + ".csv");
              }

              if (prefix) {
                filename = typeof prefix === 'string' || typeof prefix === 'number' ? prefix + "_" + filename : new Date().getTime() + "_" + filename;
              }

              blob = new Blob(["" + bomCode + csv], {
                type: 'text/csv;charset=utf-8'
              });
              FileSaver.saveAs(blob, filename);
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    return _this;
  }

  CsvDownload.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        text = _a.text;

    if (typeof children === 'undefined') {
      return React.createElement("button", {
        onClick: this.handleClick,
        type: "button"
      }, text ? text : 'Download');
    }

    return React.createElement("div", {
      onClick: this.handleClick,
      onKeyPress: this.handleClick,
      role: "button",
      tabIndex: 0
    }, children);
  };

  CsvDownload.defaultProps = {
    bom: true,
    columns: false,
    noHeader: false,
    separator: ','
  };
  return CsvDownload;
}(React.Component);

exports.default = CsvDownload;